import type { ReactNode } from "react";

import { tokens } from "@core/theme/tokens";

// Revisión en vivo 2026-09-22, punto #21: todos los diálogos del portal llevan
// el mismo encabezado que el editor de "Nueva recompensa" (admin.jsx:2450):
// arriba un eyebrow chico (`.label`) y debajo el título `h3.display` de 23px.
// Se extrajo de `EditorHeader` sin cambiar su DOM ni sus valores; lo que ese
// editor suma a la derecha (selector de idioma e indicador de estado) llega
// acá como `aside` y solo lo pasa quien ya lo tenía.
//
// El eyebrow usa `tokens.text.secondary` y no el `--text3` de `.label`
// (resolución W-SCOPE-01, 2026-10-06): `#6C6E73` sobre el fondo del diálogo
// (`#16161A`) da 3,53:1 y axe `color-contrast` exige 4,5:1 para 10,5px
// normal. `--text3` es un token del prototipo (DESIGN-TOKENS.md); la
// corrección usa otro token existente, sin hex nuevo.
export function DialogHeader({
  eyebrow,
  title,
  aside,
}: {
  eyebrow: ReactNode;
  title: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 14,
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          className="label"
          style={{ marginBottom: 7, color: tokens.text.secondary }}
        >
          {eyebrow}
        </div>
        <h3 className="display" style={{ fontSize: 23, margin: 0 }}>
          {title}
        </h3>
      </div>
      {aside ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flex: "none",
          }}
        >
          {aside}
        </div>
      ) : null}
    </div>
  );
}
